module.exports = __webpack_public_path__ + "/login_ui/img/pn-1c9eed3f630d96e50043829d56de5afb.svg";